import { AndroidInterface } from "@/apps/credit-line/services/android.service";
import { isAndroid } from "@/apps/credit-line/helpers/platformChecker.helper";

declare const Android: AndroidInterface;

export const AndroidFinishLoadingHelper = (): void => {
  if (isAndroid()) {
    Android.finishedLoading();
  }
};
